import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ErrorBoundary from "./errorsManagement/ErrorBoundary";
import Fallback from "./errorsManagement/Fallback";
import AuthNav from "./login/AuthNav";
import Login from "./login/Login";
import SignUp from "./login/SignUp";
import VerifySignup from "./login/VerifySignup";
import ForgotPassword from "./login/ForgotPassword";
import VerifyReset from "./login/VerifyReset";
import ResetPassword from "./login/ResetPassword";
import useAuthStore from "./store/authStore";
import Content from "./components/Content";

// Protected route component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuthStore();
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function App() {
  return (
    <ErrorBoundary fallback={<Fallback />}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/verify" element={<VerifySignup />} />
          
          {/* Password Reset Routes */}
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/verify-reset" element={<VerifyReset />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <Content/>
            </ProtectedRoute>
          } />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
